import {
  SCRAPE_HOTELS_PATH,
  SCRAPE_PATH_PREFIX,
  getScrapeUserId,
  isScrapePath,
} from "@waypoint/shared";

export {
  SCRAPE_HOTELS_PATH,
  SCRAPE_PATH_PREFIX,
  getScrapeUserId,
  isScrapePath,
};

export const buildScrapeAccessTokenEndpoint = (
  pathname: string,
  search: string
) => {
  if (!isScrapePath(pathname)) {
    return "/api/access-token";
  }

  return `/api/access-token/scrape${search || ""}`;
};
